import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getBasedComponents, getSidebarMenu } from '@/services/api'
import type { BasedComponent } from '@/interfaces/basedComponents'

export const useSidebarStore = defineStore('sidebar', () => {
  const activeSection = ref('courses')
  const components = ref<BasedComponent[]>([])
  const isLoading = ref(false)
  const loaded = ref(false)
  const lastActiveItems = ref<Record<string, string>>({})
  const expandedSections = ref<Set<string>>(new Set())


  function setSection(section: string) {
    activeSection.value = section
  }



  function toggleSection(id: string) {
    const s = new Set(expandedSections.value)
    s.has(id) ? s.delete(id) : s.add(id)
    expandedSections.value = s
  }

  function isExpanded(id: string) {
    return expandedSections.value.has(id)
  }

  function setLastActiveItem(section: string, route: string) {
    lastActiveItems.value[section] = route
  }

  function reset() {
    activeSection.value = 'courses'
    components.value = []
    isLoading.value = false
    loaded.value = false
    lastActiveItems.value = {}
    expandedSections.value = new Set()
  }

  async function loadComponents(force = false) {
    if (loaded.value && !force) return
    isLoading.value = true
    try {
      const res = await getBasedComponents()
      components.value = res.data.data ?? []
      loaded.value = true
    } finally {
      isLoading.value = false
    }
  }

  // For user-facing sidebar: only published
  async function loadPublishedComponents(force = false) {
    if (loaded.value && !force) return
    isLoading.value = true
    try {
      const res = await getSidebarMenu()
      components.value = res.data.data ?? []
      loaded.value = true
    } finally {
      isLoading.value = false
    }
  }

  return {
    activeSection,
    components,
    isLoading,
    loaded,
    setSection,
    setLastActiveItem,
    loadComponents,
    loadPublishedComponents,
    lastActiveItems,
    expandedSections,
    toggleSection,
    isExpanded,
    reset,
  
  }
})